import { useSupplierStore } from '@ar/stores/SupplierStore';
import axios, { AxiosResponse } from 'axios';
import { StatusCodes } from 'http-status-codes';
import Session from 'supertokens-web-js/recipe/session';
import { ArTokenResponse } from './authStrategies/ArTokenStrategyBase';

const { accountsReceivableApi } = process.env.BASE_URLS || {};

/**
 * New Auth system which uses supertokens to replace existing system.
 */
export class AuthProvider {
    private static instance: AuthProvider;

    private constructor() {
        // singleton
    }

    public static getInstance(): AuthProvider {
        if (!AuthProvider.instance) {
            AuthProvider.instance = new AuthProvider();
        }
        return AuthProvider.instance;
    }

    public async me(email: string, customerId?: string): Promise<void> {
        try {
            const response: AxiosResponse<ArTokenResponse> = await axios
                .get(`${accountsReceivableApi}/me`)
                .catch(() => { throw new Error('An error has occurred while fetching user data!'); });

            if (response.status !== StatusCodes.OK) {
                return;
            }

            const userData = response.data;
            const isNotchEmail = ['notchordering.com', 'notch.financial'].includes(email?.split('@')[1]);
            const isCustomer = !!userData?.customer_id && !userData?.supplier_id;
            const isSupplier = !!userData.supplier_id && !userData?.customer_id;
            const isCustomerAndSupplier = !!userData.supplier_id && !!userData?.customer_id;
            // saving supplier data in store
            let supplierLoginData = { ...userData,
                email,
                isNotchEmail,
                isCustomer,
                isSupplier,
                isCustomerAndSupplier };
            const customerToPreselect = !!customerId && supplierLoginData.customers.find((customer) => customer.id === customerId);
            if (customerToPreselect) {
                supplierLoginData = {
                    ...supplierLoginData,
                    customer_id: customerToPreselect.id,
                    customer_business_name: customerToPreselect.businessName,
                    currency: customerToPreselect.currency,
                    customer_country: customerToPreselect.country
                };
            }

            useSupplierStore.getState().setSupplierLoginData(supplierLoginData);

            return;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public async logOut(): Promise<void> {
        try {
            await Session.signOut();
        } catch (err) {
            console.error('Error signing out using supertokens:', err);
        }
    }
}
